import { useContext } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  Grid,
  Switch,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactTagInput from "@pathofdev/react-tag-input";
import "@pathofdev/react-tag-input/build/index.css";

import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import Card from "../../../../components/cards/Card";
import useProdutoController from "../controllers/ProdutoController";
import Chip from "../../../../components/basics/Chip";
import {
  HeaderAccordion,
  HeaderCard,
  ContainerEditor,
} from "../styles/Produto";
import { ProdutoContext } from "../contexts/ProdutoContext";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";

export default function AccordionProdutoFichaTecnicaComercial() {
  const {
    datasheetWeight,
    setDatasheetWeight,
    datasheetCubage,
    setDatasheetCubage,
    datasheetWidth,
    setDatasheetWidth,
    datasheetHeight,
    setDatasheetHeight,
    datasheetLength,
    setDatasheetLength,
    datasheetAnvisa,
    setDatasheetAnvisa,
    datasheetGeneric,
    setDatasheetGeneric,
    datasheetObservation,
    setDatasheetObservation,
    datasheetBlockNf,
    setDatasheetBlockNf,
    datasheetBlockCf,
    setDatasheetBlockCf,

    /** [QES-2838] Comentário temporário **/
    // datasheetPublishedPrice,
    // setDatasheetPublishedPrice,
    // datasheetTrackPrice,
    // setDatasheetTrackPrice,

    datasheetCommercialPartner,
    setDatasheetCommercialPartner,
    datasheetCommercialPercent,
    setDatasheetCommercialPercent,
    datasheetLastSale,
    setDatasheetLastSale,
    datasheetLastPurchase,
    setDatasheetLastPurchase,
    datasheetLastBudget,
    setDatasheetLastBudget,
    dataSheetTags,
    setDataSheetTags,
    dataEditor,
    setDataEditor,
    datasheetDepth,
    setDatasheetDepth,
    datasheetDescriptionANP,
    setDatasheetDescriptionANP,
    datasheetGlpPetroleum,
    setDatasheetGlpPetroleum,
    datasheetNationalGas,
    setDatasheetNationalGas,
    datasheetImportedGas,
    setDatasheetImportedGas,
    datasheetStartingValueWithoutICMS,
    setDatasheetStartingValueWithoutICMS,

    listCommercialPartner,
    expanded,
    loadingInputs,
    loading,
    errors,
    mainCodeAnp,
    setMainCodeAnp,
  } = useContext(ProdutoContext);
  const { queryParams } = useContext(QueryParamsContext);
  const { handleChangeOpenAcordion, handleCodeAnp } = useProdutoController();

  const onEditorStateChange = (editorState) => {
    setDataEditor(editorState);
  };

  const exibir = false;

  const show = queryParams.idversao !== "16";

  return (
    <Grid item xs={12}>
      <Accordion
        expanded={expanded.datasheet || false}
        onChange={() => handleChangeOpenAcordion("datasheet")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <HeaderAccordion>
            <Grid container>
              <Grid item xs={12}>
                <Chip
                  bgcolor={
                    !expanded.datasheet &&
                    errors.accordions &&
                    errors.accordions.includes("datasheet")
                      ? "red"
                      : "default"
                  }
                  textcolor={
                    !expanded.datasheet &&
                    errors.accordions &&
                    errors.accordions.includes("datasheet")
                      ? "white"
                      : "default"
                  }
                  label="FICHA TÉCNICA / COMERCIAL / COMBUSTÍVEL"
                />
              </Grid>
            </Grid>
          </HeaderAccordion>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2} alignItems="center">
            <Grid item lg={3} md={3} sm={6} xs={12}>
              <TextFieldErp
                error={errors.datasheetAnvisa ? true : false}
                helperText={errors.datasheetAnvisa || ""}
                label="Registro Anvisa"
                maxLength={120}
                value={datasheetAnvisa}
                setValue={setDatasheetAnvisa}
              />
            </Grid>
            <Grid item lg={3} md={3} sm={6} xs={12}>
              <TextFieldErp
                error={errors.datasheetWeight ? true : false}
                helperText={errors.datasheetWeight || ""}
                label="Peso"
                maxLength={15}
                value={datasheetWeight}
                setValue={setDatasheetWeight}
                mask="decimal"
                decimals={3}
              />
            </Grid>

            <Grid item lg={3} md={3} sm={6} xs={12}>
              <TextFieldErp
                error={errors.datasheetCubage ? true : false}
                helperText={errors.datasheetCubage || ""}
                label="Cubagem"
                maxLength={10}
                value={datasheetCubage}
                setValue={setDatasheetCubage}
                mask="decimal"
                decimals={3}
              />
            </Grid>

            <Grid item lg={3} md={3} sm={6} xs={12}>
              <TextFieldErp
                error={errors.datasheetWidth ? true : false}
                helperText={errors.datasheetWidth || ""}
                label="Largura"
                maxLength={10}
                value={datasheetWidth}
                setValue={setDatasheetWidth}
                mask="decimal"
                decimals={3}
              />
            </Grid>

            <Grid item lg={3} md={3} sm={6} xs={12}>
              <TextFieldErp
                error={errors.datasheetHeight ? true : false}
                helperText={errors.datasheetHeight || ""}
                label="Altura"
                maxLength={10}
                value={datasheetHeight}
                setValue={setDatasheetHeight}
                mask="decimal"
                decimals={3}
              />
            </Grid>

            <Grid item lg={3} md={3} sm={6} xs={12}>
              <TextFieldErp
                error={errors.datasheetLength ? true : false}
                helperText={errors.datasheetLength || ""}
                label="Comprimento"
                maxLength={10}
                value={datasheetLength}
                setValue={setDatasheetLength}
                mask="decimal"
                decimals={3}
              />
            </Grid>
            <Grid item lg={3} md={3} sm={6} xs={12}>
              <TextFieldErp
                label="Profundidade"
                maxLength={10}
                value={datasheetDepth}
                setValue={setDatasheetDepth}
                mask="decimal"
                decimals={3}
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <TextFieldErp
                error={errors.datasheetObservation ? true : false}
                helperText={errors.datasheetObservation || ""}
                label="Observação"
                maxLength={120}
                value={datasheetObservation}
                setValue={setDatasheetObservation}
              />
            </Grid>
            <Grid item flex={1}>
              <FormControlLabel
                control={
                  <Switch
                    checked={datasheetGeneric}
                    onChange={() => setDatasheetGeneric((current) => !current)}
                    color="primary"
                  />
                }
                label="Produto Genérico"
                labelPlacement="end"
              />
            </Grid>
            <Grid item xs={12} container spacing={3}>
              <Grid item md={12} xs={12}>
                <Card line="left" lineColor="primary">
                  <HeaderCard>
                    <Grid container>
                      <Chip
                        label="ESPECIFICAÇÕES TÉCNICAS"
                        bgcolor="secondary"
                      />
                    </Grid>
                  </HeaderCard>
                  <Grid item flex={1}>
                    <ContainerEditor>
                      <Editor
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorClassName"
                        editorState={dataEditor}
                        onEditorStateChange={onEditorStateChange}
                      />
                    </ContainerEditor>
                  </Grid>
                  {exibir && (
                    <Grid item flex={1}>
                      <ReactTagInput
                        tags={dataSheetTags}
                        placeholder="Criação de Tags"
                        maxTags={10}
                        editable={true}
                        readOnly={false}
                        removeOnBackspace={true}
                        onChange={(newTags) => setDataSheetTags(newTags)}
                      />
                    </Grid>
                  )}
                </Card>
              </Grid>

              <Grid item md={6} xs={12}>
                <Card line="left" lineColor="primary">
                  <HeaderCard>
                    <Grid container>
                      <Chip
                        label="ESPECIFICAÇÕES COMERCIAIS"
                        bgcolor="secondary"
                      />
                    </Grid>
                  </HeaderCard>

                  <Grid container spacing={3} alignItems="center">
                    <Grid item flex={1}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={datasheetBlockNf}
                            onChange={() =>
                              setDatasheetBlockNf((current) => !current)
                            }
                            color="primary"
                          />
                        }
                        label="Bloquear em Notas Fiscais"
                        labelPlacement="end"
                      />
                    </Grid>

                    <Grid item flex={1}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={datasheetBlockCf}
                            onChange={() =>
                              setDatasheetBlockCf((current) => !current)
                            }
                            color="primary"
                          />
                        }
                        label="Bloquear em Cupom Fiscal"
                        labelPlacement="end"
                      />
                    </Grid>

                    {/* [QES-2838] Comentário temporário */}
                    {/* <Grid item flex={1}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={datasheetPublishedPrice}
                            onChange={() =>
                              setDatasheetPublishedPrice((current) => !current)
                            }
                            color="primary"
                          />
                        }
                        label="Produto com Preço Divulgado"
                        labelPlacement="end"
                      />
                    </Grid>

                    <Grid item flex={1}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={datasheetTrackPrice}
                            onChange={() =>
                              setDatasheetTrackPrice((current) => !current)
                            }
                            color="primary"
                          />
                        }
                        label="Acompanhar Preço do Produto"
                        labelPlacement="end"
                      />
                    </Grid> */}

                    <Grid item container spacing={2}>
                      {queryParams.utilizaparceirocomercial === "SIM" && (
                        <>
                          <Grid item sm={6} xs={12}>
                            <SelectErp
                              error={
                                errors.datasheetCommercialPartner ? true : false
                              }
                              helperText={
                                errors.datasheetCommercialPartner || ""
                              }
                              loading={
                                loadingInputs.listCommercialPartner || false
                              }
                              label={
                                queryParams.labelparceirocomercial ||
                                "Parceiro Comercial"
                              }
                              value={datasheetCommercialPartner}
                              setValue={setDatasheetCommercialPartner}
                              optionsList={listCommercialPartner}
                              descriptionField="nome"
                            />
                          </Grid>

                          <Grid item sm={6} xs={12}>
                            <TextFieldErp
                              label="Percentual(%)"
                              value={datasheetCommercialPercent}
                              setValue={setDatasheetCommercialPercent}
                              mask="decimal"
                            />
                          </Grid>
                        </>
                      )}

                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <TextFieldErp
                          disabled
                          // type="date"
                          label="Última Venda"
                          value={datasheetLastSale}
                          setValue={setDatasheetLastSale}
                        />
                      </Grid>

                      {show && (
                        <Grid item lg={4} md={4} sm={6} xs={12}>
                          <TextFieldErp
                            disabled
                            // type="date"
                            label="Última Compra"
                            value={datasheetLastPurchase}
                            setValue={setDatasheetLastPurchase}
                          />
                        </Grid>
                      )}

                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <TextFieldErp
                          disabled
                          // type="date"
                          label="Último Orçamento"
                          value={datasheetLastBudget}
                          setValue={setDatasheetLastBudget}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item md={6} xs={12}>
                <Card line="left" lineColor="primary">
                  <HeaderCard>
                    <Grid container spacing={1}>
                      <Grid item xs>
                        <Chip label="COMBUSTÍVEL" bgcolor="secondary" />
                      </Grid>
                    </Grid>
                  </HeaderCard>

                  <Grid container spacing={2} alignItems="center">
                    <Grid item md={4} xs={6}>
                      <TextFieldErp
                        label="Código ANP"
                        maxLength={60}
                        value={mainCodeAnp}
                        setValue={setMainCodeAnp}
                        onBlur={() => {
                          handleCodeAnp(mainCodeAnp);
                        }}
                        type="number"
                      />
                    </Grid>

                    <Grid item md={4} xs={6}>
                      <TextFieldErp
                        loading={loading}
                        label="Descrição ANP"
                        maxLength={60}
                        value={datasheetDescriptionANP}
                        setValue={setDatasheetDescriptionANP}
                      />
                    </Grid>

                    <Grid item md={4} xs={6}>
                      <TextFieldErp
                        label="% GLP Derivado do Petróleo"
                        maxLength={20}
                        value={datasheetGlpPetroleum}
                        setValue={setDatasheetGlpPetroleum}
                        mask="decimal"
                        decimals={4}
                      />
                    </Grid>

                    <Grid item md={4} xs={6}>
                      <TextFieldErp
                        label="% Gás Natural Nacional"
                        maxLength={20}
                        value={datasheetNationalGas}
                        setValue={setDatasheetNationalGas}
                        mask="decimal"
                        decimals={4}
                      />
                    </Grid>

                    <Grid item md={4} xs={6}>
                      <TextFieldErp
                        label="% Gás Natural Importado"
                        maxLength={20}
                        value={datasheetImportedGas}
                        setValue={setDatasheetImportedGas}
                        mask="decimal"
                        decimals={4}
                      />
                    </Grid>

                    <Grid item md={4} xs={6}>
                      <TextFieldErp
                        label="Valor de partida Sem ICMS"
                        maxLength={20}
                        value={datasheetStartingValueWithoutICMS}
                        setValue={setDatasheetStartingValueWithoutICMS}
                        mask="decimal"
                        decimals={4}
                      />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
